<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-img
              :src="images.ecozenWhite"
              class="mx-2"
              max-height="40"
              max-width="100"
              contain
            ></v-img>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Email"
                prepend-icon="mdi-mail"
                type="text"
                v-model="email"
                :rules="rules"
              />

              <v-text-field
                id="password"
                label="Password"
                prepend-icon="mdi-lock"
                type="password"
                v-model="password"
                :rules="rules"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="loginToDashboard"
              :loading="loginLoading"
              >Login</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      loginLoading: false,
      rules: [value => !!value || 'Required'],
      images: {
        ecozenWhite:
          'https://api.ecozen.ai/dashboard/assets/images/logos/ecozen_white.png'
      },
      valid: true
    };
  },
  methods: {
    async loginToDashboard() {
      if (this.$refs.form.validate()) {
        // start the login process
        this.loginLoading = true;
        await this.$store.dispatch('user/login', {
          email: this.email,
          password: this.password
        });
        // finish the login process
        this.loginLoading = false;
      }
    }
  }
};
</script>
